export const sraDomain = 'https://sra-api.test.tis.coke.com'
export const sraPortalDomain = 'https://sra.test.tis.coke.com'
export const sraSfdcDomain = 'https://ccnag--cmrpuat.sandbox.my.salesforce.com'
export const domain = 'https://api.test.tis.coke.com'
export const azureClientId = 'f65d7be5-6dc8-4cd2-8527-0b51097db4d1'
export const azureTenantId = 'eb36d020-2c35-44de-bc7a-554cc979b26d'
export const apiKey = '3raCXCKojA7H7CcinqaZuYJGlp6qJ3z5THbLkz6c'
export const stage = 'test'
export const featureFlags = {
  isShareEnabled: true
}